import { fetchTimetableData } from "./fetchTimetableData";

export const timetableMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  if (
    action.type === 'timetable/toggleFilter' ||
    action.type === 'timetable/resetFilter'  ||
    action.type === 'timetable/setWeekRange' ||
    action.type === 'timetable/setMonthRange' ||
    action.type === 'timetable/setDay'       ||
    action.type === 'timetable/setType'      ||
    action.type === 'timetable/setPeriodMode'
  ) {
    store.dispatch(fetchTimetableData());
  }

  return result;
};
